module.exports = __webpack_public_path__ + "static/panna-5cf1595c9726bf30455ec30ecf3af46a.png";